// eslint-disable-next-line import/no-cycle
import useJwt from "@/auth/jwt/useJwt";
import ability from "@/libs/acl/ability";
import { initialAbility } from "@/libs/acl/config";
import axios from "@axios";

export default {
  namespaced: true,
  state: {
    privileges: null,
    userData: null,
  },
  mutations: {
    SET_PRIVILEGE: (state, payload) => {
      state.privileges = payload;
    },
    SET_USER_DATA: (state, payload) => {
      state.userData = payload;
    },
  },

  actions: {
    handlePermission({ commit }, payload) {
      const tempPrivileges = [
        { subject: "Auth", action: "read" },
        { subject: "Dashboard", action: "read" },
      ];

      if (payload.role === null || payload.role.length === 0) {
        const noRolePrivilege = { action: "Account", subject: "SignIn" };
        commit("SET_PRIVILEGE", noRolePrivilege);
        ability.update([noRolePrivilege]);
      } else {
        payload.role.modules.forEach((res) => {
          if (res.controllers != null || res.controllers.length > 0) {
            res.controllers.forEach((privilege) => {
              privilege.actions.forEach((action) => {
                tempPrivileges.push({
                  subject: privilege.name,
                  action: action.name,
                });
              });
              privilege.morePermissions.forEach((action) => {
                tempPrivileges.push({
                  subject: privilege.name,
                  action: action.name,
                });
              });
            });
          }
        });
        commit("SET_PRIVILEGE", tempPrivileges);
        ability.update(tempPrivileges);
      }
    },
    async fetchUserData({ commit, state }) {
      if (state.userData) return; // already fetched, skip
      const res = await axios.get("User/api/V1.0/Account/GetCompaniesByUserId");
      if (!localStorage.getItem("defaultMerchantId")) {
        localStorage.setItem(
          "defaultMerchantId",
          JSON.stringify(res.user.defaultMerchantId),
        );
      }
      commit("SET_USER_DATA", res);
    },

    handleLogout({ commit }) {
      localStorage.removeItem("defaultMerchantId");
      commit("SET_PRIVILEGE", []);
      commit("SET_USER_DATA", null);
      ability.update(initialAbility); // restore initial so Auth routes are still accessible
    },
  },
};
